export const useLinksStore = defineStore('linksStore', {
    state: () => ({
        links: [],
    }),
    getters: {
        getLinkByCode: (state) => {
            return (code: string) =>
                // @ts-ignore
                state?.links.find((link) => link.endsWith(code));
        },
    },
    actions: {
        updateLinks(header) {
            this.links = header.map((menuItem) => menuItem?.children?.map((submenuItem) => submenuItem?.url)).flat();
        },
    },
    persist: false,
});
